module.exports = __webpack_public_path__ + "static/img/9364_phase_function_Paper_PointsHejduk_Prediction.9702c82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/9364_phase_function_Paper_PointsHejduk_Prediction.png
// module id = +8RO
// module chunks = 0